import React from "react";
import ConnectManager from "../../components/ConnectManager";

export default function ConnectAdmin() {
  return <ConnectManager />;
}
